module.exports = __webpack_public_path__ + "img/main7.9f94e221.png";